import React from 'react'
import { Mask, Button, LoadMore } from 'react-weui'
import { connect } from 'react-redux'
import leftPad from 'left-pad'
import axios from 'axios'
import { WKInfiniteScroll } from '../../components/wk'


class ChannelGroupBuyListModal extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            list: null,
            offset: 0,
            hasMore: true,
            isPending: false,
            foo: null,
        }
    }

    componentDidMount () {
        this.timer = setInterval(() => {
            this.setState({ foo: 1 })
        }, 1000)
        this.fetchGroupBuyList()
    }

    componentWillUnmount () {
        clearInterval(this.timer)
    }

    fetchGroupBuyList () {
        this.setState({ isPending: true })
        axios.get(`/api/marketing/group_buy/${this.props.groupId}/list`, {
            params: {
                offset: this.state.offset,
            }
        })
            .then(res => {
                const data = res.data.data
                this.setState({
                    offset: data.next_offset,
                    hasMore: data.has_more,
                    list: (this.state.list || []).concat(data.activity_list),
                    isPending: false,
                })
            })
    }

    onClickClose () {
        this.props.dispatch({
            type: 'CHANNEL_SET_IS_SHOW_GROUP_BUY_LIST_MODAL',
            payload: false,
        })
    }

    getDeadline (deadline) {
        const offset = deadline - Date.now() / 1000
        if (offset < 0) {
            this.setState({ 
                deadlineInfo: { 
                    hour: '00', 
                    minute: '00', 
                    second: '00',
                }
            })
            setTimeout(() => {
                this.fetchChannelInfo(true)
            }, 1000)
            clearInterval(this.timer)
            return
        }
        const hour = Math.floor(offset / 3600) 
        const minute = Math.floor((offset - hour * 3600) / 60)
        const second = Math.floor((offset - hour * 3600 - minute * 60))
        return `${leftPad(hour, 2, '0')}:${leftPad(minute, 2, '0')}:${leftPad(second, 2, '0')}`
    }

    onClickJoin (id) {
        location.assign(`/channel/group_buy?id=${id}`)
    }

    getName (name) {
        if (name.length > 5) {
            return `${name.slice(0, 5)}...`
        } else {
            return name
        }
    }

    onTouchMoveModal (e) {
        e.preventDefault()
    }

    render() {
        const { list, isPending, hasMore } = this.state
        return (
            <div className="channel-group-buy-list-modal-wrap">
                <Mask />
                <div className="channel-group-buy-list-modal" onTouchMove={e => this.onTouchMoveModal(e)}>
                    <div className="group-buy-list" ref={r => this.$modal = r}>
                        {
                            list && list.slice(0, 5).map(item => (
                                <div className="group-buy-item wk-border-line-after" key={item.id}>
                                    <div className="left">
                                        <div className="avatar">
                                            <img src={item.leader.avatar_url} alt=""/>
                                        </div>
                                        <div className="left-right">
                                            <div className="left-right-inner">
                                                <div className="name">
                                                    <div className="nickname">{this.getName(item.leader.nickname)}</div>
                                                    <div className="sub-name">还差{item.remain_num}人</div>
                                                </div>
                                                {
                                                    Date.now() / 1000 > item.deadline && <div className="time">已结束</div>
                                                }
                                                {
                                                    Date.now() / 1000 <= item.deadline && (
                                                        <div className="time">
                                                            剩余{this.getDeadline(item.deadline)}结束
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="join-btn" onClick={e => this.onClickJoin(item.id)}>
                                            拼团
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    { !list && <LoadMore loading></LoadMore> }
                    
                    <Button className='close' onClick={e => this.onClickClose()}>关闭</Button>
                </div>
                {/*
                    this.$modal && (
                        <WKInfiniteScroll 
                            onTouchBottom={() => this.fetchGroupBuyList()}
                            isStop={isPending} 
                            isKill={!hasMore} 
                            isShowLoading={true} 
                            el={this.$modal}
                        />
                    )
                */}
                
            </div>
        )
    }
}


export default connect(state => ({
    channelGroupBuyList: state.channel.channelGroupBuyList,
}))(ChannelGroupBuyListModal)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelGroupBuyListModal.js